import { render } from "./LastfmForm.vue?vue&type=template&id=5518f790&ts=true"
import script from "./LastfmForm.vue?vue&type=script&lang=ts"
export * from "./LastfmForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__